import { render } from "./tester-frontend-user-action-buttons.vue?vue&type=template&id=22558452"
import script from "./tester-frontend-user-action-buttons.vue?vue&type=script&lang=js"
export * from "./tester-frontend-user-action-buttons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__